import React from 'react'

export const ChooseSection = () => {
  return (
    <>
      {/* ===== WHY STAYEASE ===== */}
      <section style={{ background: "#fff" }}>
        <div className="container">
          <h2 className="zzx_section-title text-center">Why Choose StayEase?</h2>
          <p className="zzx_section-sub text-center">
            Millions of travellers trust us every year
          </p>
          <div className="row g-4 mt-2">
            <div className="col-6 col-md-3">
              <div className="zzx_why-card">
                <div className="zzx_why-icon">
                  <i className="bi bi-shield-check-fill" />
                </div>
                <h5>Secure Booking</h5>
                <p>Your payments are protected with 256-bit SSL encryption.</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="zzx_why-card">
                <div className="zzx_why-icon">
                  <i className="bi bi-tag-fill" />
                </div>
                <h5>Best Price Guarantee</h5>
                <p>Found a cheaper rate? We'll match it, no questions asked.</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="zzx_why-card">
                <div className="zzx_why-icon">
                  <i className="bi bi-headset" />
                </div>
                <h5>24/7 Support</h5>
                <p>Our team is available round-the-clock to assist you.</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="zzx_why-card">
                <div className="zzx_why-icon">
                  <i className="bi bi-award-fill" />
                </div>
                <h5>Genius Rewards</h5>
                <p>Earn points on every booking and unlock exclusive perks.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  )
}

